module.exports = __webpack_public_path__ + "img/Send_hor.svg";